<template>
    <footer class="site-footer">
		<div class="site-footer-one" v-if="enableFooterOne">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<div class="content">
							<img src="@/assets/includes/snv.webp" alt="SNV" height="100px">
							<img src="@/assets/includes/caja_valores.webp" alt="Caja de Valores" width="228px" height="60px">
							<img src="@/assets/includes/bolsavalorescaracas.gif" alt="Bolsa de Valores de Caracas" height="100px">
						</div>
					</div> <!-- /.col-md-12 -->
				</div> <!-- /.row -->
			</div> <!-- /.container -->
		</div>
		<div class="site-footer-two" v-if="enableFooterTwo">
			<div class="container-fluid">
				<div class="row" v-if="items.length > 0">
					<div class="col-md-12">
						<nav class="footer-nav clearfix">
							<ul class="footer-menu">
								<template v-for="(item,index) in items">
									<li v-if="item.name && !item.children" :class="active == item.name ? 'active' : ''" :key="index">
										<router-link :to="{name: item.name, query: {lang: lang}}">{{item.label[lang]}}</router-link>
									</li>
									<li v-else-if="item.name && item.children" :class="active == item.name || item.children.map(i => i.name).includes(active) ? 'active' : ''" :key="index">
										<router-link :to="{name: item.name, query: {lang: lang}}">{{item.label[lang]}}</router-link>
									</li>
								</template>
								
							</ul> <!-- /.footer-menu -->
						</nav> <!-- /.footer-nav -->
					</div> <!-- /.col-md-12 -->
				</div> <!-- /.row -->
				<div class="row copyright-text">
					<div class="col-md-6">
						<social-media :list="socialMedia" />
					</div>
					<div class="col-md-6">
						<div class="text" style="line-height: normal">© 2009 by Inversiones Crece Pymes C.A.</div>
					</div> <!-- /.col-md-12 -->
				</div> <!-- /.row -->
			</div> <!-- /.container -->
		</div>
	</footer> <!-- /.site-footer -->
</template>

<script>
// @ is an alias to /src
import SocialMedia from '@/components/SocialMedia.vue'

export default {
  	name: 'footer-full',
  	props: {
		items: {
			type: Array,
			default: function() {
				return []
			}
		},
		active: {
			type: String
		},
		lang: {
			type: String,
			default: 'es'
		},
		enableFooterOne: {
			type: Boolean,
			default: true,
		},
		enableFooterTwo: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		SocialMedia
	},
	data() {
		return {
			socialMedia: [
				{
					icon: 'twitter',
					link: 'http://twitter.com/icrecepymes'
				},
				{
					icon: 'instagram',
					link: 'http://instagram.com/inversionescrecepymes'
				},
				{
					icon: 'facebook',
					link: 'https://www.facebook.com/Inversiones-Crecepymes-108827237464266'
				}
			]
		}
	}
}
</script>
